// src/components/Magazine/Michelangelo.js
import React, {useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';

import '../../styles/magazineGallery.scss';

function Offtown() {
  /*Costruire react things */
    let data=[
        {
            id: 1,
            imgSrc: '/images/OFFTOWN/OFFTOWN_1.jpg',
        },
        {
            id: 2,
            imgSrc: '/images/OFFTOWN/OFFTOWN_2.jpg',
        },
        {
            id: 3,
            imgSrc: '/images/OFFTOWN/OFFTOWN_3.jpg',
        },
        {
            id: 4,
            imgSrc: '/images/OFFTOWN/OFFTOWN_4.jpg',
        },
        
    ]
    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempImgSrc] = useState('');
    const getImg = (imgSrc) =>{
        setTempImgSrc(imgSrc);
        setModel(true);
    }
  return (
    <>
    <div className={model ? "model open" : "model"}>
        <img src={tempimgSrc} alt="OFFTOWN" />
        <CloseIcon onClick={()=> setModel(false)} />
    </div>
        <div className="gallery">
            {data.map((item, index)=>{
                return(
                    <div className='pics' key={index} onClick={()=> getImg(item.imgSrc)}>
                        <img src={item.imgSrc} alt="OFFTOWN" style={{width: '100%'}} loading="lazy"/>
                    </div>
                )
            })}
        </div>
     
    </>
  );
}

export default Offtown;
